import { axiosInstance } from '../lib/api_client'

type CreateParams = Readonly<{
  imageData: string
  detect: boolean
}>

type CreateResponse = Readonly<{
  id: number
  imageUrl: string
  ordinality?: number
}>

type UnitImageRepository = Readonly<{
  create: (unitId: number, params: CreateParams) => Promise<CreateResponse>
  delete: (unitId: number, unitImageId: number) => Promise<void>
  batchUpdateOrdinalities: (unitId: number, unitImageIds: number[]) => Promise<void>
}>

const unitImagesRepository: UnitImageRepository = {
  async create (unitId, params) {
    return await axiosInstance.post(`/units/${unitId}/unit_images`, params).then(({ data }) => data)
  },
  async delete (unitId, unitImageId) {
    return await axiosInstance.delete(`/units/${unitId}/unit_images/${unitImageId}`)
  },
  async batchUpdateOrdinalities (unitId, unitImageIds) {
    return await axiosInstance.put(`/units/${unitId}/unit_images/batch_update_ordinalities`, { unitImageIds })
  },
}

export { unitImagesRepository }
